function Header() {
    return (
        <header className='header'>
            <h1>zbal</h1>
        </header>
    )
}

export default Header
